import React, { ChangeEvent, ReactElement } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
import clsx from 'clsx';
import mixPanel from 'src/utils/mixpanel';
import { MIXPANEL_TRACK } from 'src/utils/consts';

interface ModalReasonOtherProps {
  otherReason: string;
  onOtherReasonChange: (val: string) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    textAlign: 'left',
    border: '1px solid #A9AAAC',
    borderRadius: 12,
    minWidth: 450,
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('xs')]: {
      minWidth: 200,
      marginBottom: '10%',
    },
  },
  majorReason: {
    fontSize: 18,
    padding: theme.spacing(2),
    lineHeight: '21px',
    fontWeight: 600,
    color: '#7157FF',
    background: '#EBF1FA',
  },

  inputReason: {
    width: '100%',
    height: '100%',
    flexGrow: 1,
    '& .MuiOutlinedInput-input': {
      borderRadius: 12,
      minHeight: 100,
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 500,
      color: '#000',
    },
    '& .MuiInputBase-inputMultiline': {
      border: 'none',
      flex: 1,
      alignItems: 'flex-start',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
}));

const ModalReasonOther = (props: ModalReasonOtherProps): ReactElement => {
  const { otherReason, onOtherReasonChange } = props;
  const classes = useStyles();

  React.useEffect(() => {
    mixPanel(MIXPANEL_TRACK.NOT_SURE_WHATS_WRONG_TEXTBOX);
  });

  const handleChange = (evt: ChangeEvent<{ value: string }>) => {
    const v = evt.target.value as string;
    onOtherReasonChange(v);
  };

  return (
    <Box
      className={clsx(
        'quote-service-modal-not-sure-reason-other',
        classes.root
      )}
    >
      <TextField
        className={classes.inputReason}
        onChange={handleChange}
        value={otherReason}
        placeholder="Describe the problem you are facing"
        multiline
      />
    </Box>
  );
};

ModalReasonOther.defaultProps = {};

export default ModalReasonOther;
